import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import DemoLanding from "@/pages/DemoLanding";
import DemoArticle from "@/pages/DemoArticle";
import DemoProduct from "@/pages/DemoProduct";
import DevNav from "@/components/DevNav";
import PasswordGate from "@/components/PasswordGate";
import { CommentsProvider } from "@/components/comments/CommentsProvider";
import CommentsOverlay from "@/components/comments/CommentsOverlay";

// The internal test harness for the Pinlayr review engine (the "widget").
// Lives behind the existing shared-password Beta gate and is intentionally
// kept separate from the SaaS platform auth. Mounted at /demo/*.
const useIsDesktop = () => {
  const query = "(min-width: 1024px)";
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : true
  );
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e) => setIsDesktop(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);
  return isDesktop;
};

export default function DemoHarness() {
  const isDesktop = useIsDesktop();
  return (
    <PasswordGate>
      <CommentsProvider>
        <Routes>
          <Route path="landing" element={<DemoLanding />} />
          <Route path="article" element={<DemoArticle />} />
          <Route path="product" element={<DemoProduct />} />
          <Route path="*" element={<Navigate to="/demo/landing" replace />} />
        </Routes>
        <DevNav />
        {isDesktop && <CommentsOverlay />}
      </CommentsProvider>
    </PasswordGate>
  );
}
